import React from "react"
import { Button, Card, Col, Row } from "react-bootstrap"
import { Link } from "react-router-dom"
import Loader from "../shared/Loader"
import ModalConfirmaCierre from "../tricel/ModalConfirmaCierre"
import { getDateWithHour} from "./../../utils"
const CardVotaciones = props => {
	const { votaciones, loader, isHistorial = false, tricel = false, confirmaCierre } = props

	const estadoProceso = estado => {
		switch (estado) {
			case "abierto":
				return "PROCESO ABIERTO"
			case "cerrado":
				return "PROCESO CERRADO"
			case "definicion":
				return "PROCESO EN PREPARACIÓN"
			default:
				break
		}
	}

	const generateCards = () => {
		return votaciones?.map((x, index) => {
			return (
				<Col lg={4} key={index} className="mb-3 d-flex">
					<Card className="card-hover">
						<Card.Body>
							<Card.Title>{x.nombre}</Card.Title>
							<Card.Text>
								<i>
									{estadoProceso(x.estado)} <br />
								</i>
								Unidad: <b>{x.unidad.nombre}</b>
							</Card.Text>
							<Card.Text>
								{x.descripcion}.
							</Card.Text>
							<small className="text-muted">
								<b>Desde</b> {getDateWithHour(x.desde)} <br/> <b> Hasta</b> {getDateWithHour(x.hasta)}
							</small>
						</Card.Body>
						{tricel ? (
							<Card.Footer className="text-center">
								<Link
									to={{ pathname: "/resultados", votacion: x }}
									className="btn btn-block btn-primary"
								>
									Resultados
								</Link>
								<Link
									to={{ pathname: "/padron", votacion: x }}
									className="btn btn-block btn-primary"
								>
									Padrón Electoral
								</Link>
								{x.estado === "abierto" ? (
									<Button
										variant="danger"
										className="my-2"
										block
										onClick={() => confirmaCierre(x)}
									>
										CERRAR VOTACIÓN
									</Button>
								) : (
									<Button variant="secondary" disabled block>
										PROCESO CERRADO
									</Button>
								)}
							</Card.Footer>
						) : (
							<Card.Footer className="text-center">
								{x.voto_emitido || isHistorial ? (
									<Button variant="secondary" disabled block>
										Voto ya emitido
									</Button>
								) : (
									<Link
										to={{ pathname: "/votausuario", votacion: x }}
										className="btn btn-block btn-primary"
									>
										Participar
									</Link>
								)}
							</Card.Footer>
						)}
					</Card>
				</Col>
			)
		})
	}

	if (votaciones?.length > 0 || loader === false) {
		return (
			<Row>
				{loader && <Loader />}
				{generateCards()}
			</Row>
		)
	} else {
		return <Loader />
	}
}

export default CardVotaciones
